import { render } from "./dlt-1.vue?vue&type=template&id=783cbb97&scoped=true"
import script from "./dlt-1.vue?vue&type=script&lang=js"
export * from "./dlt-1.vue?vue&type=script&lang=js"

import "./dlt-1.vue?vue&type=style&index=0&id=783cbb97&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783cbb97"]])

export default __exports__